import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { EmpathySection } from './components/EmpathySection';
import { AgitationSection } from './components/AgitationSection';
import { RevelationSection } from './components/RevelationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-body text-dark selection:bg-sage/30" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <EmpathySection data-id="element-4" />
        <AgitationSection data-id="element-5" />
        <RevelationSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <OfferSection data-id="element-8" />
        <FaqSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <CtaSection data-id="element-11" />
      </main>

      <Footer data-id="element-12" />
    </div>;
}